import { toast } from 'sonner';

import { useUpdateCustomerType } from '@/hooks/useCustomerType';

interface DeleteCustomerAccountParams {
  email: string;
  displayName?: string;
  onSuccess?: () => void;
}

export function useDeleteCustomerAccount() {
  const updateCustomerType = useUpdateCustomerType();

  const deleteCustomerAccount = async ({
    email,
    displayName,
    onSuccess,
  }: DeleteCustomerAccountParams) => {
    try {
      await updateCustomerType.mutateAsync({
        email,
        customerType: 'DELETE',
      });

      toast.success(
        `Account for ${displayName || email} has been marked for deletion`
      );

      onSuccess?.();
    } catch {
      toast.error('Failed to delete account');
      throw new Error('Failed to delete account');
    }
  };

  return {
    deleteCustomerAccount,
    isPending: updateCustomerType.isPending,
  };
}
